export default {
  isMember(state) {
    return !!(state.user && state.user.roles && state.user.roles.member);
  },
  isAdmin(state) {
    return !!(state.user && state.user.roles && state.user.roles.admin);
  },
  isInviter(state) {
    return !!(state.user && state.user.roles && state.user.roles.inviter);
  },
  disableEasyNavigation(state) {
    return !state.auth && !localStorage.getItem('wasLoggedId');
  },
  cachedPosts(state) {
    const cache = {};

    (state.posts || []).forEach((post) => {
      const key = post.publicKey ? `${post.alias}-${post.publicKey}` : post.alias;
      cache[key] = post;
    });

    return cache;
  },
  updates(state) {
    const updates = {};

    (state.unreadNotifications || []).forEach((notification) => {
      const postId = notification.data.post.id;
      if (postId) {
        updates[postId] = updates[postId] || {};

        if (notification.type === 'commentAdded') {
          updates[postId].comment = true;
        }
      }
    });

    return updates;
  },
};



// WEBPACK FOOTER //
// ./src/store/getters.js